var _path, _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoupon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 22V16.5C3.38071 16.5 4.5 15.3807 4.5 14C4.5 12.6193 3.38071 11.5 2 11.5V6H24V11.5C22.6193 11.5 21.5 12.6193 21.5 14C21.5 15.3807 22.6193 16.5 24 16.5V22H2Z",
    fill: "#E6ECF3"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_672_100",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_672_100)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 20V14.5C2.38071 14.5 3.5 13.3807 3.5 12C3.5 10.6193 2.38071 9.5 1 9.5V4H23V9.5C21.6193 9.5 20.5 10.6193 20.5 12C20.5 13.3807 21.6193 14.5 23 14.5V20H1ZM8.5 9.5C8.5 8.94745 8.94724 8.5 9.49953 8.5C10.0522 8.5 10.5 8.94786 10.5 9.5C10.5 10.0521 10.0522 10.5 9.49953 10.5C8.94725 10.5 8.5 10.0525 8.5 9.5ZM9.49953 7.5C8.39444 7.5 7.5 8.39569 7.5 9.5C7.5 10.6043 8.39444 11.5 9.49953 11.5C10.6042 11.5 11.5 10.6047 11.5 9.5C11.5 8.39528 10.6042 7.5 9.49953 7.5ZM15.4 8.30003C15.5657 8.07912 15.5209 7.76571 15.3 7.60003C15.0791 7.43434 14.7657 7.47912 14.6 7.70003L8.60003 15.7C8.43434 15.9209 8.47912 16.2343 8.70003 16.4C8.92094 16.5657 9.23434 16.5209 9.40003 16.3L15.4 8.30003ZM14.4995 13.5C13.9472 13.5 13.5 13.9477 13.5 14.4995C13.5 15.0525 13.9474 15.5 14.4995 15.5C15.0521 15.5 15.5 15.0521 15.5 14.4995C15.5 13.9481 15.0523 13.5 14.4995 13.5ZM12.5 14.4995C12.5 13.3958 13.3945 12.5 14.4995 12.5C15.6042 12.5 16.5 13.3954 16.5 14.4995C16.5 15.6044 15.6044 16.5 14.4995 16.5C13.3943 16.5 12.5 15.604 12.5 14.4995Z",
    fill: "#195096"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoupon);
export default __webpack_public_path__ + "static/media/Coupon.beca54e3f5e3b60b30a0286b67aaf0e7.svg";
export { ForwardRef as ReactComponent };